<div class="ui segment">
	<h3 class="ui center aligned header">Search for new players</h3>
	<input class="input" [(ngModel)]="filterQuery" />
	<div *ngFor="let player of players | userfilter:filterQuery" class="ui list">
		<div class="ui button" (click)="invitePlayer(player.UserID)">Grant access</div>
		{{ player.Username }}
	</div>
</div>
